/**
 * Z-Index System Constitution
 * 
 * Centralized registry for all application layers.
 * NEVER use magic numbers (e.g., 999999) in the codebase.
 * Import this constant to assign z-indices.
 */

export const Z_INDEX = {
    // Base layer (Content)
    BASE: 0,

    // Floating content relative to parent context (Dropdowns, Popovers)
    FLOAT: 40,

    // Tooltips (Must be above Floats but below Fixed Headers)
    TOOLTIP: 50,

    // Sticky Global Elements (Navbars, Tab Bars)
    STICKY_HEADER: 100,

    // Overlays (Modals, Dialogs, Sidebars)
    OVERLAY: 1000,

    // Critical Notifications (Toasts, Error Alerts)
    // Must be the highest layer in the application
    TOAST: 9999,
} as const
